var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Oups, page introuvable !")]),_c('EbBanner',{attrs:{"isActive":"","type":"error","displayCloseButton":false}},[_vm._v("La page que vous recherchez n'existe pas ou a été supprimée. Nous vous prions de nous excuser pour la gêne occasionnée.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }